<template>
  <SearchWidget />
</template>
    
    <script>
    import SearchWidget from '@/components/widget/search/index.vue'
    
    export default {
      name: 'SearchWidgetPage',
      components: { SearchWidget },
    }
    </script>